export const ellipsisFilter = (value, length) => {  
    return value.length > length ? value.substring(0, length - 3) + "..." : value;
};


// WEBPACK FOOTER //
// ./src/filters/ellipsis.js